import i18n, { InitOptions } from "i18next";
import { initReactI18next } from "react-i18next";
import translations from "./Utils/locales/translations.json"; // Adjust the path if necessary
import { Lang } from "./Utils/Constants";

const options: InitOptions = {
  resources: {
    En: {
      translation: translations.En,
    },
    Fr: {
      translation: translations.Fr,
    },
  },
  lng: localStorage.getItem("i18nextLng") || Lang.En,
  fallbackLng: Lang.En,
  interpolation: {
    escapeValue: false,
  },
  detection: {
    // Specify where the language is detected from
    order: ["localStorage", "navigator"],
    caches: ["localStorage"],
  },
  react: {
    useSuspense: false, // Prevents suspension while loading translations
  },
};

i18n
  .use(initReactI18next)
  .init(options)
  .catch((error) => {
    console.error("Error initializing i18n:", error);
    alert("Error loading translations. Please try again later.");
  });

// Save the selected language in local storage when the language changes
i18n.on("languageChanged", (lng: string) => {
  localStorage.setItem("i18nextLng", lng); // Store language in localStorage
  document.documentElement.lang = lng === Lang.En ? Lang.en : Lang.fr;
});

export default i18n;
